import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CustomerPerformancesOverview, PerformanceOverview } from '../customers/performances-overview/performance-overview.interface';
import { PerformanceContractCustomer } from './performance.interface';
import { PerformanceService } from './performance.service';
import { mergeCustomerPerformancesOverviewPages } from '@/core/helpers/merge-paginated-performances-overview.helper';

const service = new PerformanceService();

export interface PerformanceState {
   contractCustomers: { [key: string]: Array<PerformanceContractCustomer> };
   performancesOverviews: {
      [key: string]: {
         [customerId: number]: Array<PerformanceOverview>;
      };
   };
}

const PerformanceStore: Module<PerformanceState, StoreState> = {
   namespaced: true,
   state: {
      contractCustomers: {},
      performancesOverviews: {},
   },
   getters: {},
   mutations: {
      SET_CONTRACT_CUSTOMERS(state, payload: { dateRange: string; contractCustomers: Array<PerformanceContractCustomer> }) {
         return (state.contractCustomers[payload.dateRange] = payload.contractCustomers || []);
      },
      SET_CONTRACT_CUSTOMERS_PERFORMANCES_OVERVIEW(
         state,
         payload: { dateRange: string; customersPerformancesOverview: Array<CustomerPerformancesOverview> },
      ) {
         try {
            const { dateRange, customersPerformancesOverview } = payload;
            const performancesOverviewByCustomer: { [customerId: number]: Array<PerformanceOverview> } = {};
            for (const customerOverview of customersPerformancesOverview) {
               performancesOverviewByCustomer[customerOverview.id] = customerOverview.performances_overview;
            }

            state.performancesOverviews[dateRange] = performancesOverviewByCustomer;
         } catch (ex) {
            console.warn(ex);
         }
      },
      MERGE_CONTRACT_CUSTOMERS_PERFORMANCES_OVERVIEW(
         state,
         payload: { dateRange: string; customersPerformancesOverview: Array<CustomerPerformancesOverview> },
      ) {
         try {
            const { dateRange, customersPerformancesOverview } = payload;
            const existingCustomers = Object.entries(state.performancesOverviews[dateRange] ?? {}).map(
               ([customerId, performances_overview]) => ({
                  id: Number(customerId),
                  name: '',
                  performances_overview,
               }),
            );
            const mergedCustomers = mergeCustomerPerformancesOverviewPages(existingCustomers, customersPerformancesOverview);

            const performancesOverviewByCustomer: { [customerId: number]: Array<PerformanceOverview> } = {};
            for (const customerOverview of mergedCustomers) {
               performancesOverviewByCustomer[customerOverview.id] = customerOverview.performances_overview;
            }

            state.performancesOverviews[dateRange] = performancesOverviewByCustomer;
         } catch (ex) {
            console.warn(ex);
         }
      },
   },
   actions: {
      async deletePerformance(context, payload: { contractId: number; performanceId: number }) {
         return await service.deleteContractPerformance(payload.contractId, payload.performanceId);
      },
   },
};

export default PerformanceStore;
